// removed by extract-text-webpack-plugin
module.exports = {"iframe":"src-node_modules-kts-platform-frame-appSdk-openApp-UI-AppContainer__iframe--11RAK","spin":"src-node_modules-kts-platform-frame-appSdk-openApp-UI-AppContainer__spin--1dQgQ"};


//////////////////
// WEBPACK FOOTER
// ./src/node_modules/kts-platform-frame/appSdk/openApp/UI.AppContainer.scss
// module id = 4329
// module chunks = 0